// Global variables — exposed on window so index.js.erb (evaluated via eval) can access them
window.currentPage = 1;
window.isLoading = false;
window.hasMorePages = true;

// Function to initialize card interactions
function initializeCardInteractions() {
  document.querySelectorAll(".card-tab-section:not([data-initialized])").forEach(section => {
    section.setAttribute('data-initialized', 'true');
    
    const toggleBtn = section.querySelector(".toggleBtn");
    const offerWrapper = section.querySelector(".offerWrapper");
    const eligibilityWrapper = section.querySelector(".eligibilityWrapper");
    const arrowIcon = section.querySelector("#arrowIcon");    
  
    let expanded = false;

    if (toggleBtn) {
      toggleBtn.addEventListener("click", () => {
        const willExpand = !expanded;
        expanded = willExpand;

        const toggleSection = (el) => {
          if (el) {
            // Add transition classes for smooth animation
            if (!el.classList.contains("transition-all")) {
              el.classList.add("transition-all", "duration-500", "ease-in-out", "overflow-hidden");
            }
            
            if (willExpand) {
              // Expanding: from collapsed to expanded
              el.style.maxHeight = "3rem";
              requestAnimationFrame(() => {
                el.style.maxHeight = el.scrollHeight + "px";
              });
              
              // After animation completes, remove max-height to allow dynamic content
              el.addEventListener('transitionend', function handler() {
                if (expanded) {
                  el.style.maxHeight = "none";
                }
                el.removeEventListener('transitionend', handler);
              });
            } else {
              // Collapsing: from expanded to collapsed
              el.style.maxHeight = el.scrollHeight + "px";
              requestAnimationFrame(() => {
                el.style.maxHeight = "3rem"; // 48px (h-12)
              });
            }
            
            const fadeOverlay = el.querySelector(".fadeOverlay");
            if (fadeOverlay) {
              if (!fadeOverlay.classList.contains("transition-opacity")) {
                fadeOverlay.classList.add("transition-opacity", "duration-500", "ease-in-out");
              }
              
              if (willExpand) {
                // Hide overlay when expanding
                fadeOverlay.classList.add("opacity-0", "pointer-events-none");
                setTimeout(() => {
                  fadeOverlay.classList.add("hidden");
                }, 500); // Match transition duration
              } else {
                // Show overlay when collapsing
                fadeOverlay.classList.remove("opacity-0", "pointer-events-none");
                fadeOverlay.classList.remove("hidden");
              }
            }
          }
        };

        toggleSection(offerWrapper);
        toggleSection(eligibilityWrapper);

        const spanElement = toggleBtn.querySelector("span");
        if (spanElement) {
          spanElement.textContent = expanded
            ? I18n.t("hide_offer_details")
            : I18n.t("view_offer_details");
        }

        if (arrowIcon) {
          if (!arrowIcon.classList.contains("transition-transform")) {
            arrowIcon.classList.add("transition-transform", "duration-300", "ease-in-out");
          }
          arrowIcon.classList.toggle("rotate-180");
        }
      });
    }
  
    section.querySelectorAll(".details-tab-change").forEach(tab => {
      tab.addEventListener("click", function () {
        section.querySelectorAll(".details-tab-change").forEach(t => {
          t.classList.remove("border-b-[3px]", "border-primary", "text-primary");
        });
        this.classList.add("border-b-[3px]", "border-primary", "text-primary");
  
        const tabName = this.dataset.tab;
        if (offerWrapper) offerWrapper.classList.toggle("hidden", tabName !== "offerWrapper");
        if (eligibilityWrapper) eligibilityWrapper.classList.toggle("hidden", tabName !== "eligibilityWrapper");

        // Reset to collapsed state when switching tabs
        if (expanded) {
          expanded = false;
          [offerWrapper, eligibilityWrapper].forEach(el => {
            if (el) {
              el.style.maxHeight = "3rem";
              const fadeOverlay = el.querySelector(".fadeOverlay");
              if (fadeOverlay) {
                fadeOverlay.classList.remove("opacity-0", "pointer-events-none", "hidden");
              }
            }
          });
          const spanElement = toggleBtn?.querySelector("span");
          if (spanElement) spanElement.textContent = I18n.t("view_offer_details");
          if (arrowIcon) arrowIcon.classList.remove("rotate-180");
        }
      });
    });
  });
}

// Helper functions for bank filter
function updateApplyButtonState() {
  const applyButton = document.getElementById('filter_apply_text_bank');
  if (!applyButton) return;
  
  const selectedCount = document.querySelectorAll('.add-merchant:checked').length;
  
  if (selectedCount === 0) {
    applyButton.classList.add('opacity-50', 'cursor-not-allowed');
    applyButton.disabled = true;
  } else {
    applyButton.classList.remove('opacity-50', 'cursor-not-allowed');
    applyButton.disabled = false;
  }
}

function updateChips() {
  const selectedCheckboxes = document.querySelectorAll('.add-merchant:checked');
  const chipsContainer = document.getElementById('selected-banks');
  if (!chipsContainer) return;
  
  chipsContainer.innerHTML = '';
  
  if (selectedCheckboxes.length > 0) {
    chipsContainer.classList.add('border-b', 'border-light-border', 'dark:border-dark-border', 'mb-3');
    
    selectedCheckboxes.forEach(checkbox => {
      const bankName = checkbox.getAttribute('data-bank-name');
      const bankId = checkbox.value;
      
      const chip = document.createElement('div');
      chip.className = 'bank-chip cursor-pointer mr-2 mb-1 py-1 px-2 rounded-full text-xs bg-secondary-icon-light dark:bg-secondary-icon-dark text-white dark:text-primary-text-light font-medium inline-block';
      chip.setAttribute('data-bank-id', bankId);
      chip.textContent = bankName;
      
      chip.addEventListener('click', function() {
        checkbox.checked = false;
        updateApplyButtonState();
        updateChips();
      });
      
      chipsContainer.appendChild(chip);
    });
  } else {
    chipsContainer.classList.remove('border-b', 'border-light-border', 'dark:border-dark-border', 'mb-3');
  }
}

// Function to initialize bank filter checkbox events
function initializeBankCheckboxes() {
  const checkboxes = document.querySelectorAll('.add-merchant');
  
  // Remove existing event listeners by cloning
  checkboxes.forEach(checkbox => {
    const newCheckbox = checkbox.cloneNode(true);
    checkbox.parentNode.replaceChild(newCheckbox, checkbox);
  });
  
  // Add new event listeners
  document.querySelectorAll('.add-merchant').forEach(checkbox => {
    checkbox.addEventListener('change', function() {
      updateApplyButtonState();
      updateChips();
    });
  });
  
  // Initial state update
  updateApplyButtonState();
  updateChips();
}

// Function to initialize bank filter events
function initializeBankFilterEvents() {
  const bankFilterBtn = document.getElementById('bank-filter-btn');
  const closeBankFilterBtn = document.getElementById('close-bank-filter');
  const filterApplyBtn = document.getElementById("filter_apply_text_bank");
  const searchInput = document.getElementById("bank-filter-search");
  const cancelBtn = document.querySelector(".cancel-btn");

  // Remove old event listeners by cloning and replacing elements
  if (bankFilterBtn) {
    const newBankFilterBtn = bankFilterBtn.cloneNode(true);
    bankFilterBtn.parentNode.replaceChild(newBankFilterBtn, bankFilterBtn);
    
    newBankFilterBtn.addEventListener('click', function(){
      var bankFilter = document.getElementById('bank-filter');
      if (bankFilter.classList.contains('filter-open')) {
        closeFilterPanel(bankFilter);
      } else {
        openFilterPanel(bankFilter, newBankFilterBtn);
      }
      // Reinitialize checkboxes when filter opens
      initializeBankCheckboxes();
    });
  }

  if (closeBankFilterBtn) {
    const newCloseBankFilterBtn = closeBankFilterBtn.cloneNode(true);
    closeBankFilterBtn.parentNode.replaceChild(newCloseBankFilterBtn, closeBankFilterBtn);
    
    newCloseBankFilterBtn.addEventListener('click', function(){
      closeFilterPanel(document.getElementById('bank-filter'));
    });
  }

  if (cancelBtn) {
    const newCancelBtn = cancelBtn.cloneNode(true);
    cancelBtn.parentNode.replaceChild(newCancelBtn, cancelBtn);
    
    newCancelBtn.addEventListener("click", function () {
      const clearButton = this;
      const clearLoader = document.getElementById("clearloader");
      
      clearButton.classList.add('opacity-50', 'cursor-not-allowed');
      clearButton.style.pointerEvents = 'none';
      if (clearLoader) clearLoader.classList.remove("hidden");
      
      fetchAPI("/credit-cards", "GET").then(() => {
        document.querySelectorAll("#merchant-list input[type='checkbox']").forEach(cb => cb.checked = false);
        document.getElementById("applied-filter-count").innerHTML = '';
        document.getElementById("applied-filter-count").classList.add("hidden");
        
        const chipsContainer = document.getElementById('selected-banks');
        if (chipsContainer) {
          chipsContainer.innerHTML = '';
          chipsContainer.classList.remove('border-b', 'border-light-border', 'dark:border-dark-border', 'mb-3');
        }
        
        closeFilterPanel(document.getElementById('bank-filter'));

        if (clearLoader) clearLoader.classList.add("hidden");
        clearButton.classList.remove('opacity-50', 'cursor-not-allowed');
        clearButton.style.pointerEvents = '';
      }).catch((error) => {
        console.error("Error clearing filters:", error);
        
        if (clearLoader) clearLoader.classList.add("hidden");
        clearButton.classList.remove('opacity-50', 'cursor-not-allowed');
        clearButton.style.pointerEvents = '';
      });
    });
  }

  if (filterApplyBtn) {
    const newFilterApplyBtn = filterApplyBtn.cloneNode(true);
    filterApplyBtn.parentNode.replaceChild(newFilterApplyBtn, filterApplyBtn);
    
    newFilterApplyBtn.addEventListener("click", function () {
      const selectedCount = document.querySelectorAll('.add-merchant:checked').length;
      
      if (selectedCount === 0) return;
      
      const loader = document.getElementById('filterloader');
      this.disabled = true;
      this.classList.add('opacity-50', 'cursor-not-allowed');
      this.textContent = '';
      if (loader) loader.classList.remove('hidden');
      
      let sel_banks = [];
      document.querySelectorAll('#merchant-list input:checked').forEach((input) => {
        sel_banks.push(input.id.split("bank-")[1]);
      });

      const category = new URLSearchParams(window.location.search).get("category");
      var params = { bank_ids: sel_banks.join(',') };
      if (category) params.category = category;

      fetchAPI("/credit-cards", "GET", params).then(() => {
        document.getElementById("applied-filter-count").innerHTML = sel_banks.length;
        document.getElementById("applied-filter-count").classList.remove("hidden");
        closeFilterPanel(document.getElementById('bank-filter'));

        if (loader) loader.classList.add('hidden');
        this.textContent = I18n.t('apply');
        updateApplyButtonState();
      }).catch((error) => {
        console.error("Error applying filters:", error);
        if (loader) loader.classList.add('hidden');
        this.textContent = I18n.t('apply');
        updateApplyButtonState();
      });
    });
  }

  if (searchInput) {
    const newSearchInput = searchInput.cloneNode(true);
    searchInput.parentNode.replaceChild(newSearchInput, searchInput);
    
    newSearchInput.addEventListener("input", function () {
      const searchTerm = this.value.trim().toLowerCase();
      const bankItems = document.querySelectorAll('#merchant-list label');
      const noResultsDiv = document.getElementById('no-results-found');
      let visibleCount = 0;
      
      bankItems.forEach(item => {
        const bankNameSpan = item.querySelector('span');
        if (bankNameSpan) {
          const bankName = bankNameSpan.textContent.toLowerCase();
          
          if (searchTerm === '' || bankName.includes(searchTerm)) {
            item.style.display = 'flex';
            visibleCount++;
          } else {
            item.style.display = 'none';
          }
        }
      });
      
      const emptyStateDiv = document.getElementById('empty-state-banks');
      const merchantList = document.getElementById('merchant-list');
      
      if (visibleCount === 0) {
        if (emptyStateDiv) emptyStateDiv.classList.remove('hidden');
        if (merchantList) merchantList.classList.add('hidden');
        if (noResultsDiv && searchTerm !== '') {
          noResultsDiv.classList.remove('hidden');
        }
      } else {
        if (emptyStateDiv) emptyStateDiv.classList.add('hidden');
        if (merchantList) merchantList.classList.remove('hidden');
        if (noResultsDiv) noResultsDiv.classList.add('hidden');
      }
    });
  }
  
  // Initialize checkboxes
  initializeBankCheckboxes();
}

document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.tab');

  // Set initial active tab
  if(window.location.href.indexOf("?category") == -1) {
    tabs[0].classList.add('text-primary', 'border-primary');
    tabs[0].classList.remove('text-black', 'text-primary-text-light' , 'dark:text-primary-text-dark', 'border-transparent');
  } else {
    tabs.forEach(tab => {
      if(window.location.href.indexOf(`?category=${tab.dataset.tabInfo}`) != -1) {
        tab.classList.remove('text-black' , 'text-primary-text-light' , 'dark:text-primary-text-dark', 'border-transparent');
        tab.classList.add('text-primary', 'border-primary');
      } else {
        tab.classList.add('text-black' , 'text-primary-text-light' , 'dark:text-primary-text-dark', 'border-transparent');
        tab.classList.remove('text-primary', 'border-primary');
      }
    })
  }
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      let url = tab.dataset.tabInfo == 'all_offers' ? "" : "?category="+tab.dataset.tabInfo
      window.location.href =  window.location.href.split('?')[0]+url;
    });
  });

  // Initialize bank filter events
  initializeBankFilterEvents();

  // Expose initializeCardInteractions globally so index.js.erb can call it after filter/tab changes
  window.initializeCardInteractions = initializeCardInteractions;

  // Initialize card interactions on page load
  initializeCardInteractions();

  // Simple infinite scroll pagination
  function loadNextPage() {
    if (window.isLoading || !window.hasMorePages) {
      return;
    }

    const nextPage = window.currentPage + 1;
    window.isLoading = true;

    // Show loading animation
    const loader = document.getElementById("pagination-animation");
    if (loader) loader.classList.remove("hidden");

    // Build URL with current filters
    const params = new URLSearchParams(window.location.search);
    params.set("page", nextPage);

    fetchAPI("/credit-cards", "GET", Object.fromEntries(params)).then(() => {
      // Hide loading animation
      if (loader) loader.classList.add("hidden");

      // Update current page only if we still have more pages
      if (window.hasMorePages) {
        window.currentPage = nextPage;
      }

      // Re-initialize card interactions for new cards
      initializeCardInteractions();

      // If no more pages, hide the show more button
      if (!window.hasMorePages) {
        const showMoreButton = document.getElementById("show_more_credit_cards");
        if (showMoreButton) {
          showMoreButton.style.display = "none";
        }
      }

      window.isLoading = false;
    })
    .catch(error => {
      console.error("Error loading more credit cards:", error);
      window.isLoading = false;
      if (loader) loader.classList.add("hidden");

      // On error, stop trying to load more pages
      window.hasMorePages = false;
    });
  }

  function checkIfNearBottom() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    
    // Detect if we're on mobile (screen width < 768px, which is md breakpoint in Tailwind)
    const isMobile = window.innerWidth < 768;
    
    // On mobile, use a larger threshold to account for footer covering the view
    // On desktop, use the original smaller threshold
    const threshold = isMobile ? Math.max(400, windowHeight * 0.4) : 200;
    const nearBottom = scrollTop + windowHeight >= documentHeight - threshold;
    
    if (nearBottom) {
      loadNextPage();
    }
  }

  // Scroll event listener
  window.addEventListener('scroll', checkIfNearBottom);
  
  // Handle window resize and orientation changes
  window.addEventListener('resize', function() {
    // Debounce resize events to avoid excessive calls
    clearTimeout(window.resizeTimeout);
    window.resizeTimeout = setTimeout(checkIfNearBottom, 100);
  });

  // Show more button functionality
  const showMoreButton = document.getElementById("show_more_credit_cards");
  if (showMoreButton) {
    showMoreButton.addEventListener("click", function() {
      loadNextPage();
    });
  }
});